import $ from 'jquery'
import isEmpty from 'lodash/isEmpty'

class MissingFeatureError extends Error {
  constructor(message) {
    super(message)

    this.name = 'MissingFeatureError'
    this.message = message
  }
}

const browserRequirements = {
  checkCookies() {
    return navigator.cookieEnabled
  },

  getMissingFeatures() {
    const features = []
    if (!this.checkCookies()) {
      features.push('cookies')
    }
    return features
  },

  checkFeatures() {
    return isEmpty(this.getMissingFeatures())
  },

  ensureAllFeatures() {
    const features = this.getMissingFeatures()
    if (isEmpty(features)) return

    const formattedFeatures = features.join(', ')

    $('body').html(`
      <header class="site-header__logotype">
        <a href="/">Everlane</a>
      </header>

      <div style="text-align: center; max-width: 640px; margin: 0 auto;">
        <h1>Sorry, your web browser is not supported.</h1>
        <p>
          Everlane.com relies on the presence of certain browser features to
          deliver our site to you. You may need to update your browser or
          check whether certain features (${formattedFeatures}) have been
          disabled. You can learn more about cookies
          <a href="https://support.google.com/chrome/answer/95647">here</a>.
        </p>
      </div>
      `)

    // Halt current thread of JS execution
    throw new MissingFeatureError(formattedFeatures)
  },
}

browserRequirements.ensureAllFeatures()

export default browserRequirements
